export default "__VITE_ASSET__4d59bc33__"